<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import WhatsappCallSelector from './WhatsappCallSelector.vue';

export default { components: { PageHeader, WhatsappCallSelector } };
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] overflow-auto"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP_CALL.TITLE')"
      :header-content="$t('INBOX_MGMT.WHATSAPP_CALLING.SELECTOR.DESCRIPTION')"
    />
    <WhatsappCallSelector />
  </div>
</template>
